import React from 'react';
import Image from 'next/image';
import styles from './carreiras.module.css';

const Carreiras: React.FC = () => {
  const navigateToJobs = () => {
    window.open('https://getninjas.breezy.hr/', '_blank');
  };

  const handleNavigateToHome = () => {
    window.open('/', '_self');
  };

  return (
    <div className={styles.container}>
      {/* Header */}
      <header className={styles.header}>
        <div className={styles.headerContent}>
          <Image
            src="/images/carreiras/getninjas-logo.webp"
            alt="GetNinjas"
            width={135}
            height={29}
            priority
          />
        </div>
      </header>

      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroOverlay}>
          <div className={styles.heroContent}>
            <h1>
              Estamos desenvolvendo um ecossistema que conecta clientes
              <br />a profissionais <strong>nunca visto antes!</strong>
            </h1>
            <a
              href="https://getninjas.breezy.hr/"
              target="_blank"
              className={styles.btnPrimary}
              rel="noreferrer"
            >
              Veja nossas vagas
            </a>
          </div>
        </div>
      </section>

      {/* Direcionadores Estratégicos */}
      <section className={styles.direcionadoresSection}>
        <div className={styles.sectionContent}>
          <h2>Nossos direcionadores estratégicos</h2>

          <div className={styles.direcionadoresIntro}>
            <p>
              Após 13 anos liderando o mercado América Latina, nosso propósito
              de conectar quem precisa com quem sabe fazer ficou pequeno para
              nós. Queremos ser o{' '}
              <strong>maior e melhor marketplace de serviços do mundo</strong>,
              entregando aos clientes soluções de serviços qualificada e segura!
            </p>
            <p>
              Se você se identifica com nossa visão de longo prazo e topa
              construir esse futuro com a gente, conheça mais sobre nossa
              cultura:
            </p>
          </div>

          <div className={styles.direcionadoresGrid}>
            <div className={styles.direcionadorCard}>
              <div className={styles.cardIcon}>
                <Image
                  src="/images/carreiras/lock.webp"
                  alt="Segurança"
                  width={70}
                  height={70}
                />
              </div>
              <h3>
                Satisfação do cliente
                <br />
                em 1º lugar
              </h3>
              <p className={styles.cardSubtitle}>
                Cada interação é uma chance de criar valor
                <br />e superar expectativas
              </p>
              <div className={styles.cardList}>
                <ul>
                  <li>Colocamos o cliente no centro</li>
                  <li>Não nos contentamos com "bom"</li>
                  <li>Somos autênticos</li>
                </ul>
              </div>
            </div>

            <div className={styles.direcionadorCard}>
              <div className={styles.cardIcon}>
                <Image
                  src="/images/carreiras/star.webp"
                  alt="Segurança"
                  width={70}
                  height={70}
                />
              </div>
              <h3>
                Segurança é<br />
                inegociável
              </h3>
              <p className={styles.cardSubtitle}>
                Garantimos um ambiente protegido,
                <br />
                priorizamos a integridade do ecossistema.
              </p>
              <div className={styles.cardList}>
                <ul>
                  <li>Todos somos guardiões</li>
                  <li>Não subestimamos riscos</li>
                  <li>Integridade é nosso foco</li>
                </ul>
              </div>
            </div>

            <div className={styles.direcionadorCard}>
              <div className={styles.cardIcon}>
                <Image
                  src="/images/carreiras/lamp.webp"
                  alt="Inovação"
                  width={70}
                  height={70}
                />
              </div>
              <h3>
                Inovar com
                <br />
                simplicidade
              </h3>
              <p className={styles.cardSubtitle}>
                Aprendemos com os erros, escolhemos
                <br />o caminho mais simples para inovar.
              </p>
              <div className={styles.cardList}>
                <ul>
                  <li>Estamos sempre em movimento</li>
                  <li>Erramos e aprendemos rápido</li>
                  <li>Valorizamos o simples</li>
                </ul>
              </div>
            </div>

            <div className={styles.direcionadorCard}>
              <div className={styles.cardIcon}>
                <Image
                  src="/images/carreiras/search.webp"
                  alt="Problema"
                  width={70}
                  height={70}
                />
              </div>
              <h3>
                Se apaixonar
                <br />
                pelo problema
              </h3>
              <p className={styles.cardSubtitle}>
                Encaramos desafios com atitude, buscamos
                <br />
                soluções criativas e colaborativas.
              </p>
              <div className={styles.cardList}>
                <ul>
                  <li>Não esperamos que a solução caia do céu</li>
                  <li>Deixar para depois está fora do radar</li>
                  <li>Construímos juntos</li>
                </ul>
              </div>
            </div>

            <div className={styles.direcionadorCard}>
              <div className={styles.cardIcon}>
                <Image
                  src="/images/carreiras/arrows.webp"
                  alt="Valor"
                  width={70}
                  height={70}
                />
              </div>
              <h3>
                Gerar valor para
                <br />
                nosso ecossistema
              </h3>
              <p className={styles.cardSubtitle}>
                Impacto está em cada decisão, entregamos
                <br />
                resultados que movem o mercado.
              </p>
              <div className={styles.cardList}>
                <ul>
                  <li>Somos experts no que fazemos</li>
                  <li>Nosso resultado é fruto do valor gerado</li>
                  <li>Evoluímos através do diálogo</li>
                </ul>
              </div>
            </div>

            <div className={styles.direcionadorCard}>
              <div className={styles.cardIcon}>
                <Image
                  src="/images/carreiras/castle.webp"
                  alt="Desafio"
                  width={70}
                  height={70}
                />
              </div>
              <h3>
                Desafio é a<br />
                nossa diversão
              </h3>
              <p className={styles.cardSubtitle}>
                Superamos limites, celebramos cada conquista
                <br />
                com energia e entusiasmo.
              </p>
              <div className={styles.cardList}>
                <ul>
                  <li>Cada segundo importa</li>
                  <li>Pensamos grande</li>
                  <li>Celebramos nossas vitórias</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className={styles.teamImage}>
        <Image
          src="/images/carreiras/team.webp"
          alt="Time"
          width={900}
          height={280}
        />
      </div>

      {/* Benefícios */}
      <section className={styles.beneficiosSection}>
        <div className={styles.beneficiosSectionContent}>
          <h2>Nossos benefícios</h2>
          <p className={styles.sectionSubtitle}>
            O QUE NOSSOS GETTERS TEM DIREITO:
          </p>

          <div className={styles.beneficiosGrid}>
            <div className={styles.beneficioCard}>
              <div className={styles.beneficioIcon}>
                <Image
                  src="/images/carreiras/money.webp"
                  alt="Finanças"
                  width={80}
                  height={80}
                />
              </div>
              <h3>Finanças</h3>
              <ul>
                <li>✅ Bônus anual (PLR)</li>
                <li>✅ VR flexível R$ 1.280/mês</li>
                <li>✅ Crédito bancário Itaú</li>
              </ul>
            </div>

            <div className={styles.beneficioCard}>
              <div className={styles.beneficioIcon}>
                <Image
                  src="/images/carreiras/health.webp"
                  alt="Saúde"
                  width={80}
                  height={80}
                />
              </div>
              <h3>Saúde</h3>
              <ul>
                <li>✅ Plano médico SulAmérica</li>
                <li>✅ Plano odonto SulAmérica</li>
                <li>✅ Desconto em farmácias</li>
              </ul>
            </div>

            <div className={styles.beneficioCard}>
              <div className={styles.beneficioIcon}>
                <Image
                  src="/images/carreiras/wealth.webp"
                  alt="Bem-estar"
                  width={80}
                  height={80}
                />
              </div>
              <h3>Bem-estar</h3>
              <ul>
                <li>✅ 2 sessões/mês no ZenKlub</li>
                <li>✅ Desconto no TotalPass</li>
                <li>✅ Dayoff aniversário</li>
              </ul>
            </div>

            <div className={styles.beneficioCard}>
              <div className={styles.beneficioIcon}>
                <Image
                  src="/images/carreiras/family.webp"
                  alt="Família"
                  width={80}
                  height={80}
                />
              </div>
              <h3>Família</h3>
              <ul>
                <li>✅ Desconto nos planos de saúde e bem-estar</li>
                <li>✅ Auxílio creche ou babá</li>
                <li>✅ Desconto no MeuPetClub</li>
                <li>✅ Seguro de vida</li>
              </ul>
            </div>

            <div className={styles.beneficioCard}>
              <div className={styles.beneficioIcon}>
                <Image
                  src="/images/carreiras/mobility.webp"
                  alt="Mobilidade"
                  width={80}
                  height={80}
                />
              </div>
              <h3>Mobilidade</h3>
              <ul>
                <li>✅ Vale transporte sem desconto</li>
                <li>✅ Estacionamento no prédio</li>
                <li>✅ Bicicletário no prédio</li>
              </ul>
            </div>

            <div className={styles.beneficioCard}>
              <div className={styles.beneficioIcon}>
                <Image
                  src="/images/carreiras/growth.webp"
                  alt="Crescimento"
                  width={80}
                  height={80}
                />
              </div>
              <h3>Crescimento</h3>
              <ul>
                <li>✅ Plataforma de aprendizado online</li>
                <li>✅ Desconto em parceiros</li>
                <li>✅ Treinamentos internos</li>
                <li>✅ Ciclos de desenvolvimento</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Depoimentos */}
      <section className={styles.depoimentosSection}>
        <div className={styles.sectionContent}>
          <h2>Depoimentos</h2>
          <p className={styles.sectionSubtitle}>
            O QUE DIZEM OS NOSSOS GETTERS:
          </p>

          <div className={styles.depoimentosGrid}>
            <div className={styles.depoimentoCard}>
              <div>
                <p className={styles.depoimentoTexto}>
                  <em>
                    Entrei no GetNinjas em 2016 como Estagiário e pude
                    acompanhar de perto todo o crescimento da empresa ao longo
                    dos anos. Hoje, tenho imenso orgulho da trajetória que
                    percorremos como time. Superamos desafios, construímos um
                    ambiente colaborativo, focado na inovação e na excelência e
                    sinto que estamos prontos para alcançarmos patamares ainda
                    mais altos.
                  </em>
                </p>
                <p className={styles.depoimentoAutor}>
                  <strong>Gabriel</strong>, Coordenador de Controladoria
                </p>
                <p className={styles.depoimentoTempo}>
                  No GetNinjas desde em 2016
                </p>
              </div>
              <Image
                src="/images/carreiras/gabriel.webp"
                alt="Gabriel"
                width={280}
                height={280}
              />
            </div>

            <div className={styles.depoimentoCardReverse}>
              <Image
                src="/images/carreiras/jessica.webp"
                alt="Jéssica"
                width={280}
                height={280}
              />
              <div>
                <p className={styles.depoimentoTexto}>
                  <em>
                    Trabalhar no GetNinjas é muito gratificante, porque sei que
                    meu trabalho ajuda milhões de profissionais de serviços a
                    crescerem e conquistarem seus sonhos. Além disso, é incrível
                    poder ajudar a construir uma cultura de produto que valoriza
                    a colaboração, sempre buscando novas tecnologias e inovações
                    para fazer a diferença.
                  </em>
                </p>
                <p className={styles.depoimentoAutor}>
                  <strong>Jéssica,</strong> Gerente de Produto
                </p>
                <p className={styles.depoimentoTempo}>
                  No GetNinjas desde 2024
                </p>
              </div>
            </div>

            <div className={styles.depoimentoCard}>
              <div>
                <p className={styles.depoimentoTexto}>
                  <em>
                    Estar cercado dos melhores profissionais do mercado, aliado
                    a uma cultura organizacional inclusiva e transparente tornam
                    o trabalho no GetNinjas cada dia mais gratificante. Orgulho
                    em pertencer.
                  </em>
                </p>
                <p className={styles.depoimentoAutor}>
                  <strong>Gabriel</strong>, Analista de Departamento Pessoal
                </p>
                <p className={styles.depoimentoTempo}>
                  No GetNinjas desde 2020
                </p>
              </div>

              <Image
                src="/images/carreiras/gabriel2.webp"
                alt="Gabriel"
                width={280}
                height={280}
              />
            </div>

            <div className={styles.depoimentoCardReverse}>
              <Image
                src="/images/carreiras/daniela.webp"
                alt="Daniela"
                width={280}
                height={280}
              />
              <div>
                <p className={styles.depoimentoTexto}>
                  <em>
                    Gratidão é a palavra que define o sentimento que tenho pelo
                    GetNinjas. É a empresa que me acolheu e me mostrou que
                    realmente os valores se fazem presentes e ativos no nosso
                    dia a dia. Me sinto uma peça importante e valorizada aqui na
                    empresa, assim sigo com muito amor e dedicação crescendo e
                    me desenvolvendo.
                  </em>
                </p>
                <p className={styles.depoimentoAutor}>
                  <strong>Daniela</strong>, Analista de Relacionamento CS
                </p>
                <p className={styles.depoimentoTempo}>
                  No GetNinjas desde 2019
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Processo Seletivo */}
      <section className={styles.selecaoSection}>
        <div className={styles.sectionSelecaoContent}>
          <h2>Nossa seleção</h2>
          <p className={styles.sectionSubtitle}>
            ETAPAS PARA FAZER PARTE DO TIME:
          </p>

          <div className={styles.selecaoTimeline}>
            <div className={styles.line}></div>

            <div className={styles.etapaItem}>
              <div className={styles.etapaNumero}>ETAPA 1</div>
              <div className={styles.etapaDescricao}>
                <h3>AVALIAÇÃO DO CURRÍCULO</h3>
                <p>
                  Analisamos seu perfil e, caso dê match com nossas
                  oportunidades em aberto, entraremos em contato por e-mail ou
                  telefone para agendar um bate-papo.
                </p>
              </div>
            </div>

            <div className={styles.etapaItem}>
              <div className={styles.etapaNumero}>ETAPA 2</div>
              <div className={styles.etapaDescricao}>
                <h3>CONVERSA COM A RECRUTADORA</h3>
                <p>
                  Iremos te apresentar o GetNinjas e oportunidade em aberto,
                  além de conhecer mais sobre sua trajetória profissional e
                  momento de carreira.
                </p>
              </div>
            </div>

            <div className={styles.etapaItem}>
              <div className={styles.etapaNumero}>ETAPA 3</div>
              <div className={styles.etapaDescricao}>
                <h3>CONVERSA COM A LIDERANÇA</h3>
                <p>
                  A liderança da posição irá apresentar com mais profundidade
                  sobre a vaga em aberto e avaliar se seu perfil se conecta com
                  o do nosso time.
                </p>
              </div>
            </div>

            <div className={styles.etapaItem}>
              <div className={styles.etapaNumero}>ETAPA 4</div>
              <div className={styles.etapaDescricao}>
                <h3>CONVERSA COM O TIME</h3>
                <p>
                  O time irá avaliar como seu conhecimento técnico se alinha às
                  necessidades da posição, além de ser uma oportunidade para
                  você conhecer a equipe.
                </p>
              </div>
            </div>

            <div className={styles.etapaItem}>
              <div className={styles.etapaNumero}>ETAPA 5</div>
              <div className={styles.etapaDescricao}>
                <h3>CONVERSA COM PARES / PARCEIROS</h3>
                <p>
                  Getters da equipe ou áreas parceiras irão mergulhar sobre o
                  dia a dia da posição, além de ser uma oportunidade para você
                  conhecer pessoas-chave do GetNinjas.
                </p>
              </div>
            </div>

            <div className={`${styles.etapaItem} ${styles.etapaExtra}`}>
              <div className={styles.etapaNumero}>ETAPA EXTRA</div>
              <div className={styles.etapaDescricao}>
                <h3>CONVERSA COM O MANAGEMENT TEAM</h3>
                <p>
                  Vamos apresentar com mais detalhes a estratégia do GetNinjas e
                  avaliar se o seu perfil e visão de negócio contribui para
                  nossos desafios.
                </p>
              </div>
            </div>

            <div className={`${styles.etapaItem} ${styles.etapaFinal}`}>
              <div className={styles.etapaNumero}>ETAPA FINAL</div>
              <div className={styles.etapaDescricao}>
                <h3>APRESENTAÇÃO DA OFERTA</h3>
                <p>
                  Chegamos ao grande momento! A liderança da posição e a
                  recrutadora vão detalhar a oferta e alinhar as expectativas
                  para que você possa se tornar um Getter.
                </p>
              </div>
            </div>
          </div>

          <div>
            <button
              className={styles.btnSecondary}
              onClick={navigateToJobs}
              id="vagas"
            >
              Confira nossas vagas
            </button>
          </div>

          <div className={styles.selecaoNotaContainer}>
            <p className={styles.selecaoNota}>
              Nossas seleções levam em média 20 a 40 dias úteis para finalizar.
              Garantimos que você receberá retorno no fim do processo,
              independente de até qual etapa avançar.
            </p>

            <Image
              src="/images/carreiras/check.webp"
              alt="LinkedIn"
              width={60}
              height={60}
              className={styles.selecaoNotaIcon}
            />
          </div>
        </div>
      </section>

      <footer className={styles.footer}>
        {/* Redes Sociais */}
        <div className={styles.footerContainer}>
          <Image
            src="/images/carreiras/getninjas-logo.webp"
            alt="GetNinjas"
            width={135}
            height={29}
            onClick={handleNavigateToHome}
            style={{
              cursor: 'pointer',
            }}
          />

          <section className={styles.sectionFooterContent}>
            <h2>Redes Sociais</h2>

            <div className={styles.redesGrid}>
              <a
                href="https://www.linkedin.com/company/getninjas/"
                target="_blank"
                className={styles.redeLink}
                rel="noreferrer"
              >
                <Image
                  src="/images/carreiras/linkedin.webp"
                  alt="LinkedIn"
                  width={40}
                  height={40}
                />
              </a>
              <a
                href="https://www.glassdoor.com.br/Vis%C3%A3o-geral/Trabalhar-na-GetNinjas-EI_IE1493964.13,22.htm"
                target="_blank"
                className={styles.redeLink}
                rel="noreferrer"
              >
                <Image
                  src="/images/carreiras/glassdor.webp"
                  alt="Glassdoor"
                  width={40}
                  height={40}
                />
              </a>
              <a
                href="https://www.instagram.com/getninjas/?hl=pt"
                target="_blank"
                className={styles.redeLink}
                rel="noreferrer"
              >
                <Image
                  src="/images/carreiras/instagram.webp"
                  alt="Instagram"
                  width={40}
                  height={40}
                />
              </a>
              <a
                href="https://www.youtube.com/channel/UCWgyIuQWHB3u88SY1hr5zZg"
                target="_blank"
                className={styles.redeLink}
                rel="noreferrer"
              >
                <Image
                  src="/images/carreiras/youtube.webp"
                  alt="YouTube"
                  width={40}
                  height={40}
                />
              </a>
            </div>
          </section>

          {/* Certificações */}
          <section className={styles.sectionFooterContent}>
            <h2>Certificações</h2>
            <div className={styles.certificacoesGrid}>
              <Image
                src="/images/carreiras/reclame-aqui.webp"
                alt="Reclame Aqui"
                width={120}
                height={40}
              />
            </div>
          </section>

          {/* Downloads */}
          <section className={styles.sectionFooterContent}>
            <h2>Downloads</h2>
            <div className={styles.appBadges}>
              <a
                href="https://play.google.com/store/apps/details?id=br.com.getninjas.pro&hl=pt&gl=US"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  src="/images/carreiras/google-play-logo.webp"
                  alt="Google Play"
                  width={100}
                  height={36}
                />
              </a>

              <a
                href="https://apps.apple.com/br/app/getninjas-para-profissional/id969564418"
                target="_blank"
                rel="noreferrer"
              >
                <Image
                  src="/images/carreiras/app-store-logo.webp"
                  alt="App Store"
                  width={100}
                  height={36}
                />
              </a>
            </div>
          </section>
        </div>

        <div className={styles.footerContent}>
          <p>
            ©2011-2024, GetNinjas LTDA. CNPJ 55.744.877/0001-89 - Rua Dr.
            Fernandes Coelho, 85 - 3º Andar - Pinheiros - São Paulo/SP - Brasil
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Carreiras;
